import api from './api';

export const email = {
  // État config (super-admin)
  getStatus: () => api.get('/email/status'),

  // Test d'envoi (super-admin) — body: { to? }
  sendTest: (to) => api.post('/email/test', { to }),

  // Envoi manuel (super-admin) — body: { to, subject, html?, text?, type? }
  send: (data) => api.post('/email/send', data),

  // Historique paginé — params: { type, statut, to_user_id, limit, offset }
  getHistory: (params = {}) => api.get('/email/history', { params }),

  // Détail d'un envoi
  getHistoryDetail: (id) => api.get(`/email/history/${id}`),

  // Suppression (super-admin)
  delete: (id) => api.delete(`/email/${id}`),
  deleteMany: (ids) => api.delete('/email', { data: { ids } }),

  // Destinataires rapports (super-admin)
  getRapportDestinataires: (params) => api.get('/email/rapport-destinataires', { params }),
  addRapportDestinataire: (data) => api.post('/email/rapport-destinataires', data),
  deleteRapportDestinataire: (id) => api.delete(`/email/rapport-destinataires/${id}`),

  // Conditions de déclenchement (même source que le pied des emails envoyés)
  getAlerteConditions: () => api.get('/email/alerte-conditions'),

  // Templates alertes email (sujet + corps)
  getAlerteTemplates: () => api.get('/email/alerte-templates'),
  updateAlerteTemplate: (typeRapport, data) => api.put(`/email/alerte-templates/${typeRapport}`, data),
};

export default email;
